export function hexToRgbChannels(hex) {
  const value = hex?.replace('#', '');

  if (!value || value.length !== 6) {
    return null;
  }

  return [0, 2, 4].map((offset) => parseInt(value.slice(offset, offset + 2), 16)).join(' ');
}

const BRAND_COLOR_VARIABLES = ['--primary-color', '--primary-color-rgb'];

export function applyBrandColor(primaryColor) {
  const channels = hexToRgbChannels(primaryColor);

  if (!channels) {
    return;
  }

  const style = document.documentElement.style;
  style.setProperty('--primary-color', primaryColor);
  style.setProperty('--primary-color-rgb', channels);
}

// Restores the FoodAmigos defaults from styles/index.css by dropping the inline overrides.
export function clearBrandColor() {
  BRAND_COLOR_VARIABLES.forEach((variable) => document.documentElement.style.removeProperty(variable));
}
